// @flow
import React from 'react';
import { IS_RENEWAL_AUTOMATION_LIVE } from '@src/constants';
import { SG_CNBC_NOTE_TEXT, SG_CNBC_RENEWAL_NOTE_TEXT } from '@components/common/sgcnbc/constants';
import { Spacer } from '@presentational/spacing/Spacer';

import { useIsEstimateRenewal } from '../../custom-hooks/useIsEstimateRenewal';
import { PositiveMessageWithHeaderText } from '../presentational/messages/PositiveMessageWithHeaderText';

export const getMaxCreditsNoteText = (isRenewal) => {
  // If the renewal automation is not live, use the old max limit of 15% of ACV note
  if (!IS_RENEWAL_AUTOMATION_LIVE) {
    return SG_CNBC_NOTE_TEXT;
  }
  // If the renewal automation is live and for renewals, use the new max limit of 15% of net new commit note
  if (isRenewal) {
    return SG_CNBC_RENEWAL_NOTE_TEXT;
  }
  // For New commit, use the old max limit of 15% of ACV note
  return SG_CNBC_NOTE_TEXT;
};

export const CNBCSGEditabilityMessageContainer = () => {
  const isRenewal = useIsEstimateRenewal();
  const maxCreditsNote = getMaxCreditsNoteText(isRenewal);

  return (
    <>
      <Spacer y={10} />
      <PositiveMessageWithHeaderText compact={true} message={maxCreditsNote} />
      <Spacer y={10} />
    </>
  );
};
